import { Logo } from '../../../components/navbar/Navbar/Navbar';
import createReducer from '../../../lib/createReducer';
import { Brand } from '../../../lib/theme';
import { MenuLink } from '../../../models/menu';
import { BOOTSTRAP, BootstrapActionPayload, LOAD_EXTERNALNAVBAR } from './actions';

interface Navbar {
  logo?: string;
  logos: Logo[];
  brand: Brand;
  links: {
    contactUsNav: MenuLink[];
    socialsNav: MenuLink[];
    mainNav: MenuLink[];
  };
  actions?: MenuLink[];
}

export interface NavbarState extends Navbar {}

export const initialState = {
  brand: undefined,
  links: {
    contactUsNav: [],
    socialsNav: [],
    mainNav: [],
  },
};

export const handleBootstrap = (
  state: NavbarState,
  {
    logo,
    logos,
    brand,
    links,
    actions,
  }: BootstrapActionPayload
): NavbarState => ({
  ...state,
  logo,
  logos,
  brand,
  links,
  actions,
});

const handlers = {
  [BOOTSTRAP]: handleBootstrap,
  [LOAD_EXTERNALNAVBAR + '_FULFILLED']: handleBootstrap,
};

export default createReducer(handlers, initialState);
